import React, { useState, useEffect } from 'react'
import { Button, DatePicker, Icon, Modal, Popconfirm, Table } from 'antd'
import moment from 'moment'

const EditorialTimelineModal = ({ visible, onClose, timelines = [], onSave }) => {
  const [periodFrom, setPeriodFrom] = useState(null)
  const [periodTo, setPeriodTo] = useState(null)
  const [list, setList] = useState(timelines)

  useEffect(() => {
    setList(timelines)
  }, [timelines])

  const handleAdd = () => {
    if (!periodFrom || !periodTo) {
      Modal.warning({ title: 'Please select both Period From and Period To dates.' })
      return
    }
    if (moment(periodTo).isBefore(moment(periodFrom))) {
      Modal.warning({ title: '"Period To" must be after "Period From".' })
      return
    }
    const entry = {
      periodFrom: periodFrom.toISOString(),
      periodTo: periodTo.toISOString()
    }
    const updated = [...list, entry]
    setList(updated)
    setPeriodFrom(null)
    setPeriodTo(null)
  }

  const handleDelete = (index) => {
    const updated = list.filter((_, i) => i !== index)
    setList(updated)
  }

  const handleSave = () => {
    onSave(list)
    onClose()
  }

  const columns = [
    {
      title: 'Period From',
      dataIndex: 'periodFrom',
      render: val => moment(val).format('MMM YYYY')
    },
    {
      title: 'Period To',
      dataIndex: 'periodTo',
      render: val => moment(val).format('MMM YYYY')
    },
    {
      title: 'Action',
      render: (_, __, index) => (
        <Popconfirm
          title={'Are you sure you want to delete this period?'}
          onConfirm={() => handleDelete(index)}
          okText={'Yes'}
          cancelText={'No'}>
          <Button type="link" icon="delete" style={{ color: 'red' }} />
        </Popconfirm>
      )
    }
  ]

  return (
    <Modal
      title={
        <span>
          <Icon type={'calendar'} style={{ marginRight: 8 }} />
          Editorial Period Timeline
        </span>
      }
      visible={visible}
      onCancel={onClose}
      width={620}
      footer={[
        <Button key={'cancel'} onClick={onClose}>Cancel</Button>,
        <Button key={'save'} type={'primary'} onClick={handleSave}>Save</Button>
      ]}>

      {/* Add new period row */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', marginBottom: 16 }}>
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Period From</label>
          <DatePicker
            style={{ width: '100%' }}
            picker={'month'}
            placeholder={'Select month & year'}
            value={periodFrom}
            onChange={val => setPeriodFrom(val)}
            format={'MMM YYYY'}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Period To</label>
          <DatePicker
            style={{ width: '100%' }}
            picker={'month'}
            placeholder={'Select month & year'}
            value={periodTo}
            onChange={val => setPeriodTo(val)}
            format={'MMM YYYY'}
          />
        </div>
        <Button type={'primary'} icon={'plus'} onClick={handleAdd}>
          Add
        </Button>
      </div>

      {/* Periods table */}
      <Table
        dataSource={list}
        columns={columns}
        rowKey={(_, i) => i}
        pagination={false}
        size={'small'}
        locale={{ emptyText: 'No editorial periods added yet.' }}
        bordered
      />
    </Modal>
  )
}

export default EditorialTimelineModal
